
const getFirstName = name => {
  try {
    name = name.trim().split(' ')[0]
    return name
  } catch (e) {
    return name
  }
}

export default getFirstName
